<template>
    <div class="tit-wrap--small">
        <div class="pb-8px pb-md-12px">
            <v-row align="center" class="row--sm">
                <div class="col col-auto">
                    <div v-if="this.$slots['titleContents']" class="txt txt--xs txt--dark font-weight-medium">
                        <slot name="titleContents" />
                    </div>
                    <h3 v-else class="txt txt--xs txt--dark font-weight-medium">{{ title }}</h3>
                </div>
                <v-spacer v-if="this.$slots['default']" />
                <div v-if="this.$slots['default']" class="col col-auto">
                    <slot />
                </div>
            </v-row>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: { type: String },
    },
    components: {},
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
